import { mapBrFromString } from '@/utils';

export default function Section({ children, block, ...props }) {
	return (
		<p
			tabIndex="-1" //needed to keep tab focus order intact after reading (onclick) this element with a screenreader.
			id={`section_description_${block.id}`}
			className="section-description"
		>
			{mapBrFromString(block.properties.description)}
		</p>
	);
}
